import { render, staticRenderFns } from "./CrudSideMenu.vue?vue&type=template&id=2584a5b4&scoped=true"
import script from "./CrudSideMenu.vue?vue&type=script&lang=js"
export * from "./CrudSideMenu.vue?vue&type=script&lang=js"
import style0 from "./CrudSideMenu.vue?vue&type=style&index=0&id=2584a5b4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2584a5b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2584a5b4')) {
      api.createRecord('2584a5b4', component.options)
    } else {
      api.reload('2584a5b4', component.options)
    }
    module.hot.accept("./CrudSideMenu.vue?vue&type=template&id=2584a5b4&scoped=true", function () {
      api.rerender('2584a5b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/components/crud-components/CrudSideMenu.vue"
export default component.exports